export default "__VITE_ASSET__2d9550e5__"